import type { CSSProperties } from "react";

/** Custom properties for a `style`: React sets them through the CSSOM, which the CSP allows (ADR-074). */
export const vars = (values: Record<`--${string}`, string | number>) => values as CSSProperties;
